import Axios from 'axios'
import navigation from '@/mixins/navigation'
import submit from '@/mixins/submit'

export default {
  // Mixins
  mixins: [navigation, submit],

  // Data
  data () {
    return {
      mortgageRoute: process.env.VUE_APP_LEAD_API_MORTGAGE_ROUTE
    }
  },

  // Computed
  computed: {
    $_submit_mortgageUrl () {
      return `${this.leadAPIUrl}${this.mortgageRoute}`
    },

    $_submit_mortgageLeadData () {
      return this.$store.getters['mortgages/leadSubmissionData']
    },

    $_submit_mortgageLeadFormData () {
      const leadData = { ...this.$_submit_mortgageLeadData }
      const formData = new FormData()

      for (const key in leadData) {
        const value = leadData[key] !== undefined ? leadData[key] : ''
        formData.append(key, value)
      }

      return formData
    }
  },

  // Methods
  methods: {
    /**
     * Submit Mortgage Lead
     * @desc submits the lead data to leadApi.
     * If it fails, call the resubmit function
     */
    async $_submit_mortgageLead () {
      if (this.submitting || this.$_submit_leadSubmitted) return
      this.submitting = true

      try {
        const isValid = await this.$_navigation_validateStep()
        if (!isValid) throw new Error('Validation failed.')

        const response = await Axios({
          method: 'POST',
          url: this.$_submit_mortgageUrl,
          data: this.$_submit_mortgageLeadFormData
        })

        const { uid } = response.data.data
        if (!uid) throw Error
        this.$store.dispatch('setLeadSubmitted', true)
        this.$store.dispatch('setAppCDUID', uid)
      } catch (error) {
        console.warn(error)
        throw error
      } finally {
        this.submitting = false
      }
    }
  }
}
